import React, { useRef, useEffect } from "react";

const YouTubeVideo = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    // Force play on mount
    if (videoRef.current) {
      videoRef.current.play().catch(err => {
        console.log("Autoplay failed:", err);
      });
    }
  }, []);

  return (
    <div style={{ height: "100%", width: "100%" }} className="desktop-only-video">
      <video
        ref={videoRef}
        src="https://s3.us-east-1.amazonaws.com/www.nocapvote.com/uploads/admanager/homepagevideo.mp4"
        muted
        loop
        playsInline
        controls
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover"
        }}
      >
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default YouTubeVideo;